export default __webpack_public_path__ + "static/media/PeepoCash.39673f21.png";